import useFetch, { Status } from '../../../../../hooks/fetch.hook';

interface IMyOffer {
  id: string;
  title: string;
  description: string;
  validUntil: string;
}

export default function MyOffers() {
  // === STATE ===
  const [{ status, data, httpResponseStatusCode }] = useFetch<IMyOffer[]>('/api/mittkonto/myoffers');

  return (
    <div className="my-offers">
      <h2>Mina erbjudanden</h2>
      {status === Status.loading && <p>Laddar...</p>}
      {status === Status.failed && httpResponseStatusCode === 401 && <p>Du är inte inloggad. Logga in för att se dina erbjudanden.</p>}
      {status === Status.failed && httpResponseStatusCode === 403 && <p>Du har inte behörighet att se dina erbjudanden.</p>}
      {status === Status.failed && httpResponseStatusCode !== 401 && httpResponseStatusCode !== 403 && <p>Något gick fel.</p>}
      {status === Status.success && data && (
        <ul>
          {data.map((offer) => (
            <li key={offer.id}>
              {offer.title} — {offer.description} (t.o.m. {offer.validUntil})
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
